import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/wave.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/download.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/player.svg';
export default {
  name: 'ProductMedia',
  props: {
    dangerousProduct: {
      type: String,
      default: ''
    },
    dangerousProductTranslated: {
      type: String,
      default: ''
    },
    videos: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    specificityLogo: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isPlaying: false,
      imagesPath: 'https://cdn.maisonsdumonde.com/images/segmentations/'
    };
  },
  computed: {
    hasVideos: function hasVideos() {
      return this.videos !== null && this.videos.length;
    }
  },
  methods: {
    labels_logos: function labels_logos(labels) {
      return Object.values(labels).filter(function (label) {
        return label.description;
      });
    }
  }
};